import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import 'react-toastify/dist/ReactToastify.css';
import { motion } from 'framer-motion';
// import {initialsUpperCase, startUpperCase} from 'utils/textFormat';

// import Loading from '../../../components/loading/Loading';
import LoadingCar from '../../../components/loading/LoadingCar';

// components
import SupplierCard from './components/SupplierCard';
import ShippingInfoDetail from './components/ShippingInfoCard';

const Services = () => {
  const title = 'Servicios';
  const description = 'Servicios Plataforma Ioenvio';
  const history = useHistory();

  // - Global State from Store.js form Values
  const { ratesData } = useSelector((state) => state.shipping_rates);
  const { insuranceData } = useSelector((state) => state.shipping_insurance);
  const { senderData } = useSelector((state) => state.shipping_sender);
  const { receiverData } = useSelector((state) => state.shipping_receiver);
  const { parcelData } = useSelector((state) => state.shipping_parcel);
  const { shippingOptions } = useSelector((state) => state.shipping_options);
  const [isLoading, setIsLoading] = useState(false);
  // console.log('insurance epack:', insuranceData.fields.isInsurance);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const shippingData = {
    // send this info to each service card component this should be available to send in the body request
    addressFrom: {
      company: senderData.fields.company,
      name: senderData.fields.name,
      phone: senderData.fields.phone,
      // email: '',
      street: senderData.fields.street,
      street_number: senderData.fields.streetNumber,
      neighborhood: senderData.fields.neighborhood,
      zip_code: senderData.fields.zip,
      reference: senderData.fields.placeRef,
    },
    addressTo: {
      company: receiverData.fields.company,
      name: receiverData.fields.name,
      phone: receiverData.fields.phone,
      // email: '',
      street: receiverData.fields.street,
      street_number: receiverData.fields.streetNumber,
      neighborhood: receiverData.fields.neighborhood,
      zip_code: receiverData.fields.zip,
      reference: receiverData.fields.placeRef,
    },
    parcel: {
      product_description: parcelData.fields.product_description,
      product_value: parseInt(parcelData.fields.product_value, 10),
      insurance: parcelData.fields.insurance,
      height: parcelData.fields.height,
      width: parcelData.fields.width,
      depth: parcelData.fields.depth,
      weight: parcelData.fields.weight,
      multi_pieces: parcelData.fields.multi_pieces,
    },
    isInsurance: insuranceData.fields.isInsurance, // just for define if insurance obj should be send
    insurance: {
      is_product_new: insuranceData.fields.isProductNew,
      commoditie_id: insuranceData.fields.commoditieId,
      beneficiary_name: insuranceData.fields.beneficiaryName,
      beneficiary_rfc: insuranceData.fields.beneficiaryRFC,
    },
    wsp_destination_notification: shippingOptions.wsp_destination_notification,
  };
  const cardVariants = {
    hidden: { opacity: 0, y: 50 }, // Empieza invisible y desplazado hacia abajo
    visible: { opacity: 1, y: 0 }, // Se vuelve visible y se posiciona
  };
  useEffect(() => {
    if (shippingData.addressFrom.name === '') {
      history.push('/envios/enviar');
    }
  }, [history, shippingData]);
  // console.log('create shipping data:', shippingData);
  // console.log('valor y tipo de dato de product_value:', shippingData.parcel.product_value, typeof shippingData.parcel.product_value);
  // console.log('data rates in services:', ratesData);
  return (
    <>
      {isLoading && <LoadingCar />}
      <div id="pageContainer">
        <HtmlHead title={title} description={description} />
        {/* Title Start */}
        <div className="page-title-container">
          <NavLink className="muted-link pb-1 d-inline-block hidden breadcrumb-back" to="/envios/enviar">
            <CsLineIcons icon="chevron-left" size="13" />
            <span className="align-middle text-small ms-1">Atrás</span>
          </NavLink>
          <h1 className="mb-0 pb-0 display-4" id="title">
            {title}
          </h1>
        </div>
        {/* Title End */}
        <Row>
          <Col xs="12" className="col-lg order-1 order-lg-1">
            {/* Items Start */}
            <h2 className="small-title">Lista disponible</h2>
            <div className="mb-5">
              {ratesData.rates?.map((rate, index) => (
                <motion.div
                  key={rate.shipping_code}
                  initial="hidden"
                  animate="visible"
                  transition={{
                    duration: 0.5,
                    delay: index * 0.2, // Retraso para animación secuencial
                  }}
                  variants={cardVariants}
                >
                  <SupplierCard key={rate?.shipping_code} rate={rate} shippingData={shippingData} setIsLoading={setIsLoading} page="shipping" />
                </motion.div>
              ))}
            </div>
            {/* Items End */}
          </Col>
          <Col xs="12" lg="auto" className="order-0 order-lg-0">
            <h2 className="small-title">Detalles del envío</h2>
            <ShippingInfoDetail shippingData={shippingData} />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Services;
